module.exports = __webpack_public_path__ + "img/driver (1).667acc4c.svg";